import {
  DxpDataLayerEvent,
  DxpDataLayerType,
} from "./customDatalayerInterface";
import { CustomDxpWindow } from "./custom.window";
import dxpDataLayerToggleVerification from "./dxpDataLayerToggleVerification";

declare let window: CustomDxpWindow;

const dxpDigitalDataAssignment = (data: DxpDataLayerType) => {
  const isDxpDataLayer = dxpDataLayerToggleVerification();
  if (isDxpDataLayer) {
    try {
      const lastIndex = window.dataLayer.length - 1;
      const lastEvent = window.dataLayer[lastIndex];
      const isLastIndex = lastEvent?.eventName === data.eventName;

      if (isLastIndex) {
        window.dataLayer[lastIndex] = {
          ...lastEvent,
          event: DxpDataLayerEvent.CONFIGURATOR,
          ...data,
        };
      } else {
        window.dataLayer.push({
          event: DxpDataLayerEvent.CONFIGURATOR,
          ...data,
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log("DataLayer error", err);
    }
  }
};


export default dxpDigitalDataAssignment;
